import { render } from "./tpl_flex_four.vue?vue&type=template&id=1693b9aa&scoped=true"
import script from "./tpl_flex_four.vue?vue&type=script&lang=js"
export * from "./tpl_flex_four.vue?vue&type=script&lang=js"

import "./tpl_flex_four.vue?vue&type=style&index=0&id=1693b9aa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1693b9aa"],['__file',"src/views/wap/template/tpl_flex_four.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1693b9aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1693b9aa', __exports__)) {
    console.log('reload')
    api.reload('1693b9aa', __exports__)
  }
  
  module.hot.accept("./tpl_flex_four.vue?vue&type=template&id=1693b9aa&scoped=true", () => {
    console.log('re-render')
    api.rerender('1693b9aa', render)
  })

}


export default __exports__